import apiClient from './api';
import { BranchTransfer, CreateBranchTransferDto, UpdateBranchTransferDto } from '../types/branchTransfers.types';

export const branchTransfersService = {
  async getAll(
    status?: string,
    fromBranchId?: number,
    toBranchId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<BranchTransfer[]> {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (fromBranchId) params.append('fromBranchId', fromBranchId.toString());
    if (toBranchId) params.append('toBranchId', toBranchId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    const query = params.toString();
    const response = await apiClient.get(`/BranchTransfers${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getById(id: number): Promise<BranchTransfer> {
    const response = await apiClient.get(`/BranchTransfers/${id}`);
    return response.data;
  },

  async create(data: CreateBranchTransferDto): Promise<BranchTransfer> {
    const response = await apiClient.post('/BranchTransfers', data);
    return response.data;
  },

  async update(id: number, data: UpdateBranchTransferDto): Promise<BranchTransfer> {
    const response = await apiClient.put(`/BranchTransfers/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/BranchTransfers/${id}`);
  },

  async approve(id: number): Promise<BranchTransfer> {
    const response = await apiClient.post(`/BranchTransfers/${id}/approve`);
    return response.data;
  },

  async unapprove(id: number): Promise<BranchTransfer> {
    const response = await apiClient.post(`/BranchTransfers/${id}/unapprove`);
    return response.data;
  },

  async receive(id: number): Promise<BranchTransfer> {
    const response = await apiClient.post(`/BranchTransfers/${id}/receive`);
    return response.data;
  },

  async unreceive(id: number): Promise<BranchTransfer> {
    const response = await apiClient.post(`/BranchTransfers/${id}/unreceive`);
    return response.data;
  },

  async post(id: number): Promise<BranchTransfer> {
    const response = await apiClient.post(`/BranchTransfers/${id}/post`);
    return response.data;
  },

  async unpost(id: number): Promise<BranchTransfer> {
    const response = await apiClient.post(`/BranchTransfers/${id}/unpost`);
    return response.data;
  },

  async generateTransferNumber(): Promise<string> {
    const response = await apiClient.get('/BranchTransfers/generate-transfer-number');
    return response.data;
  },

  // ✅ NEW: Get available stock for branch transfers
  async getAvailableStock(itemId: number, unitId: number, branchId: number): Promise<any> {
    const response = await apiClient.get(
      `/BranchTransfers/available-stock?itemId=${itemId}&unitId=${unitId}&branchId=${branchId}`
    );
    return response.data;
  },
};